import { createApp } from 'vue'
import i18n from './i18n'

// In Vue 3, Vue instances are isolated (not global).
// We need this shared Vue app factory function to be able
// to add mixins or plugins to all Vue apps.

export function createVueApp(options) {
  const app = createApp(options)
  // TODO: replace mixin with composable https://vuejs.org/guide/reusability/composables.html
  app.mixin({
    computed: {
      i18n() {
        return i18n
      }
    }
  })

  return app
}
